export const GET_RECURSOS_LOADING = 'recursos/GET_RECURSOS_LOADING';
export const GET_RECURSOS_SUCCESS = 'recursos/GET_RECURSOS_SUCCESS';
export const GET_RECURSOS_FAILURE = 'recursos/GET_RECURSOS_FAILURE';
